<template>
  <div>
      <v-layout row justify-space-between class="layout-adjustment">
        <v-flex xs4 sm5 class="padding-off">
          <v-menu
            lazy
            :close-on-content-click="false"
            v-model="menu"
            transition="scale-transition"
            offset-y
            full-width
            :nudge-right="40"
            max-width="290px"
            min-width="290px"
          >
            <v-text-field
              slot="activator"
              label="From date"
              v-model="fromDate"
              prepend-icon="event"
              readonly
            ></v-text-field>
            <v-date-picker v-model="fromDate" no-title scrollable actions>
              <template slot-scope="{ save, cancel }">
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn flat  @click="cancel">Cancel</v-btn>
                  <v-btn flat @click="save">OK</v-btn>
                </v-card-actions>
              </template>
            </v-date-picker>
          </v-menu>
        </v-flex>
        <v-flex xs4 sm5 class="padding-off">
          <v-menu
            lazy
            :close-on-content-click="false"
            v-model="menu2"
            transition="scale-transition"
            offset-y
            full-width
            :nudge-right="40"
            max-width="290px"
            min-width="290px"
          >
            <v-text-field
              slot="activator"
              label="To date"
              v-model="toDate"
              prepend-icon="event"
              readonly
            ></v-text-field>
            <v-date-picker v-model="toDate" no-title scrollable actions>
              <template slot-scope="{ save, cancel }">
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn flat  @click="cancel">Cancel</v-btn>
                  <v-btn flat @click="save">OK</v-btn>
                </v-card-actions>
              </template>
            </v-date-picker>
          </v-menu>
        </v-flex>
        <v-btn class="btn-adjustment" @click="searchLogs"><v-icon>search</v-icon></v-btn>
      </v-layout>
      <v-alert color="error" class="err" icon="warning" value="true" v-if="err">{{err}}</v-alert>      
      <div class="table__overflow">
        <table class="datatable table">
          <thead>
            <tr>
              <th role="columnheader" scope="col" class="column text-xs-left">Actions</th>
              <th role="columnheader" scope="col" class="column text-xs-center">User ID</th>
              <th role="columnheader" scope="col" class="column text-xs-center">Date</th>
            </tr>
          </thead>
          <tbody>
            <template v-for="(log, index) in logs">
              <router-link tag="tr" :to="generatePath(log.type, log.ref)" v-if="log.type" :key="index">
                <td class="text-xs-left">{{log.action}}</td>
                <td class="text-xs-center">{{log.userId}}</td>
                <td class="text-xs-center">{{log.date}}</td>
              </router-link>
              <tr v-else :key="index">
                <td class="text-xs-left">{{log.action}}</td>
                <td class="text-xs-center">{{log.userId}}</td>
                <td class="text-xs-center">{{log.date}}</td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>
  </div>
</template>

<script>
  import webHelper from '../../helpers/web';

  export default {
    data: () => ({
      fromDate: null,
      toDate: null,
      menu: false,
      menu2: false,
      headers: [
        {
          text: 'Actions',
          sortable: false,
          value: 'actions',
        },
        {
          text: 'User ID',
          sortable: false,
          value: 'userId',
        },
        {
          text: 'Date',
          sortable: false,
          value: 'date',
        },
      ],
      logs: [],
      err: '',
    }),
    methods: {
      generatePath(type, ref) {
        switch (type) {
          case 'message':
            return {
              name: 'messageConfig',
              params: {
                id: ref,
              },
            };
          case 'event': return { name: 'events' };
          case 'group': return { name: 'group' };
          case 'section': return { name: 'section' };
          case 'tv': return { name: 'tv' };
          case 'tablet': return { name: 'tablet' };
          case 'user': return { name: 'users' };
          default: return {};
        }
      },
      async searchLogs() {
        const where = {};
        if (this.fromDate && this.toDate) {
          if (new Date(this.fromDate).getTime() > new Date(this.toDate).getTime()) {
            this.err = 'From date can\'t be after to date.';
            return;
          }
        }
        if (this.fromDate) {
          Object.assign(where, { from: new Date(this.fromDate).toISOString() });
        }
        if (this.toDate) {
          Object.assign(where, { to: new Date(this.toDate).toISOString() });
        }
        const res = await webHelper.get(this, 'log', where);
        if (res.failed) {
          this.err = 'Failed to get Logs.';
          return;
        }
        this.logs = res.logs.reverse();
      },
    },
    async created() {
      const res = await webHelper.get(this, 'log');
      if (res.failed) {
        this.err = 'Failed to get Logs.';
        return;
      }
      this.logs = res.logs.reverse();
    },
  };
</script>

<style scoped lang="scss">
  .padding-off {
    padding: 0 !important;
  }
  .layout-adjustment {
    padding: 17px 36px 5px 36px;
    margin-bottom: -15px !important;
    align-items: center;
  }
  .btn-adjustment {
    min-width: 40px !important;
    margin-top: -7px !important;
  }
  table {
    border-top: 1px solid rgba(0,0,0, 0.12);
  }
  @media only screen and (max-width: 600px) {
    .layout-adjustment {
      padding: 17px 10px 5px 12px;
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/eventManager/Logs.vue